/*
 * @Author: chenlin
 * @Date: 2019-08-21 16:26:03
 * @LastEditors: chenlin
 * @LastEditTime: 2019-09-28 15:32:40
 * @Description: 公共初始化扫码
 */
export default {
  data: function () {
    return {
    }
  },
  created () {
  },
  methods: {
    /**
     * 初始扫码
     * @param {回调每个页面的方法名,因为用了混入必须不一致} businessMethodName
     * @param {页面预估码值长度,不需要一定准确,用于过滤用户键盘操作} codeLength
     */
    initScanCode (businessMethodName, codeLength) {
      let self = this
      let code = ''
      let lastTime = null
      let nextTime = null
      let lastCode = null
      let nextCode = null
      document.onkeypress = function (e) {
        nextCode = e.which
        nextTime = new Date().getTime()
        if (code.length >= codeLength) {
          if (lastCode != null && lastTime != null && nextTime - lastTime <= 2000) {
            code += String.fromCharCode(lastCode)
          } else {
            code = ''
          }
        } else {
          if (lastCode != null && lastTime != null && nextTime - lastTime <= 50) {
            code += String.fromCharCode(lastCode)
          } else {
            code = ''
          }
        }
        lastCode = nextCode
        lastTime = nextTime
        if (e.which === 13) {
          if (code !== '' && code.length > codeLength) {
            let methods = self.$options.methods
            methods[businessMethodName](code, self)
          }
          code = ''
        }
      }
    }
  }
}
